import { css } from '@emotion/react';
import { memo } from 'react';
import { fill_vertical_all_center } from '~/modules/AppLayout/FlexGridCss';
const NotFoundPage = memo(function NotFoundPage() {
    return (<div css={css `
        ${fill_vertical_all_center};
        height: 1fr;
        background-color: #eeeeee;
      `}>
      <p css={css `
          margin: 16px 32px;
          text-align: center;
          font-size: 1rem;
        `}>
        權限驗證失敗
      </p>
    </div>);
});
export default NotFoundPage;
